import React from 'react';
import {Modal, Button} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {useLocation} from 'react-router-dom';
import {useContext, useContextSelector} from 'use-context-selector';

import {LocalContext} from '../context/LocalContext';
import {SessionContext} from '../context/SessionContext';

import ModalRef from '../util/ModalRef';
import LanguageSwitch from './LanguageSwitch';
import Loader from './Loader';

const CookiesNotice = (props) => {
    const [sessionData, setSessionData] = useContext(SessionContext);
    const [localData, setLocalData] = useContext(LocalContext);
    const location = useLocation();

    const {t} = useTranslation();

    const modalVisible = useContextSelector(SessionContext, v => v[0].modalVisible);
    const userAuthenticated = useContextSelector(LocalContext, v => v[0].user.authenticated);
    const UILangSession = useContextSelector(SessionContext, v => v[0].UILang);

    return <Modal
        container={ModalRef}
        show={
            !(location.pathname === '/privacy-policy') &&
            !userAuthenticated &&
            !(process.env.REACT_APP_MAINTENANCE_MODE === 'true')
        }
        onHide={
            () => {
                if (modalVisible) {
                    setSessionData(
                        {
                            ...sessionData,
                            modalVisible: false
                        }
                    )
                }
            }
        }
        onShow={
            () => {
                if (!modalVisible) {
                    setSessionData(
                        {
                            ...sessionData,
                            modalVisible: true
                        }
                    )
                }
            }
        }
        centered={true}
    >
        <Modal.Header>
            <strong>{t("CookiesNotice.cookies-notice")}</strong>
        </Modal.Header>

        <Modal.Body>
            <p>{t("CookiesNotice.message.p1")}</p>
            <p>{t("CookiesNotice.message.p2")} <a href="/privacy-policy" target="_blank">{t("CookiesNotice.message.p3")}</a>{t("CookiesNotice.message.p4")}</p>
        </Modal.Body>

        <Modal.Footer>
            <Loader>
                <LanguageSwitch variant="secondary" />
            </Loader>
            <Button
                className="ml-auto"
                variant="primary"
                onClick={() => {
                    const expDate = new Date();
                    expDate.setDate(expDate.getDate() + parseInt(process.env.REACT_APP_EXP_DAYS_COOKIES_POLICY));

                    setLocalData({
                        ...localData,
                        UILang: UILangSession,
                        cookiesPolicy: {
                            exp: expDate,
                            accepted: true
                        }
                    });

                    setSessionData({...sessionData, modalVisible: false});
                }}
            >{t("CookiesNotice.accept")}</Button>
        </Modal.Footer>
    </Modal>
}

export default CookiesNotice;
